import { combineReducers } from 'redux';
import { encryptPersistReducer } from 'app/libs/encryptPersistReducer';
import car from './car';
import application from './application';
import contracts from './contracts';
import cashPay from './cashPay';

const escrow = combineReducers({
	car: encryptPersistReducer(
		{
			key: 'escrow.car',
		},
		car,
	),
	application: encryptPersistReducer(
		{
			key: 'escrow.application',
		},
		application,
	),
	contracts,
	cashPay,
});

export default escrow;
